import { render } from "./EditViewTrip.vue?vue&type=template&id=4df9470e"
import script from "./EditViewTrip.vue?vue&type=script&lang=js"
export * from "./EditViewTrip.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__